import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

interface HeaderSectionProps {
  isEditing: boolean;
  hasIntegration: boolean;
  isSubmitting: boolean;
  validateConfig: () => boolean;
  onSubmit: (e?: React.FormEvent) => void;
  onEdit: () => void;
  onCancel: () => void;
}

export const HeaderSection: React.FC<HeaderSectionProps> = ({
  isEditing,
  hasIntegration,
  isSubmitting,
  validateConfig,
  onSubmit,
  onEdit,
  onCancel,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        pt: 2,
      }}
    >
      <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
        AccuLynx Integration Setup
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, ml: 'auto', mt: 1.5 }}>
        {hasIntegration && !isEditing && (
          <Button
            variant="contained"
            color="primary"
            onClick={onEdit}
            startIcon={<EditIcon />}
          >
            Edit Configuration
          </Button>
        )}

        {isEditing && hasIntegration && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onSubmit}
              disabled={isSubmitting || !validateConfig()}
            >
              {isSubmitting ? 'Saving Integration...' : 'Save Integration'}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
